import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_101: FaireProductEntity = {
  token: "starter_collection_101",
  type: "product",
  name: "Niko Bar Tool Set",
  brandName: "Be Home",
  imageUrl:
    "https://cdn.faire.com/fastly/04d93e2f883a70952aee8d38b76c37b43429d3f364ac37846c3b7c27961680a5.webp?bg-color=FFFFFF&canvas=1440:1440&dpr=1&fit=bounds&format=jpg&height=1440&width=1440",
  priceDollars: 65,
  msrpDollars: 130,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
